import { createTheme } from "@mui/material/styles";

const CustomHeightTable = createTheme({
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: "none",
          boxShadow: "none",
          // height: "340px"
          // background: "#F7F8FF",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { padding: 0, letterSpacing: 0, fontFamily: "red hat display" },
        head: {
          backgroundColor: "#F7F8FF !important",
          color: "#402899",
          fontWeight: 600,
          borderBottom: "1px solid #B5BFD0",
        },
      },
    },
    MuiDialog: {
      // styleOverrides: { paper: { borderRadius: "none" } },
      styleOverrides: { root: { borderRadius: "none" } },
    },
  },
});
export default CustomHeightTable;
